<template>
    <div class="ae-card sty2">
        <img :alt="imgAlt" :src="imgUrl" v-show="show">
        <div class="mask">
            <div class="cell">
                <a :href="link" target="_blank">
                    <div class="h3" :title="title">{{title}}</div>
                </a>
                <p>
                    <span v-for="(item,index) in tags" :key="index">{{item}}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'EiMask',
		props: {
			imgUrl: {
				type: String,
				default: ''
			},
			imgAlt: {
				type: String,
				default: ''
			},
			link: {
				type: String,
				default: ''
			},
			title: {
				type: String,
				default: ''
			},
			tags: {
				type: Array,
			}
		},
		data() {
			return {
				show: false
			}
		},
		watch: {
			imgUrl: function (newV) {
				this.$set(this, "imgUrl", newV)
				this.$set(this, "show", newV !== '')
			}
		}
	}
</script>

<style scoped lang="scss">
    .ae-card.sty2 {
        margin-bottom: 30px;
        position: relative;
        display: inline-block;
        width: 785px;
        height: 360px;
        overflow: hidden;
        opacity: 0;
        background: #ddd;
        transform: translateY(50px);
        -webkit-transform: translateY(50px);
        transition: all 0.6s ease-out 0s;
        -webkit-transition: all 0.6s ease-out 0s;
        transition-delay: 0.4s;
        -webkit-transition-delay: 0.2s;

        img {
            width: 100%;
            height: 100%;
            transition: all 0.3s ease-out 0s;
            -webkit-transition: all 0.3s ease-out 0s;
        }

        video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .logo {
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            background-position: center center;
            background-repeat: no-repeat;
        }

        .mask {
            background: url(./image/bg4.png);
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            text-align: center;
            opacity: 0;
            filter: alpha(opacity='0');
            transition: all .3s ease-out 0s;
            -webkit-transition: all .3s ease-out 0s;

            .cell {
                position: absolute;
                left: 0;
                top: 50%;
                width: 100%;
                transform: translateY(-50%);
                -ms-transform: translateY(-50%);
            }

            .h3 {
                font-size: 36px;
                color: #fff;
                transform: translateY(-20px);
                -ms-transform: translateY(-20px);
                transition: all .3s ease-out 0s;
                -webkit-transition: all .3s ease-out 0s;
            }

            p {
                font-size: 16px;
                color: #fff;
                margin-top: 20px;
                padding: 0 20px;
                transform: translateY(20px);
                -webkit-transform: translateY(20px);
                transition: all .3s ease-out 0s;
                -webkit-transition: all .3s ease-out 0s;
            }

            p span {
                margin: 0 10px;
                display: inline-block;
            }
        }
    }

    .ae-card.sty2 {
        transform: translateY(0);
        -webkit-transform: translateY(0);
        opacity: 1;
    }

    .ae-card.sty2:hover {
        img {
            filter: blur(5px);
        }

        .mask {
            opacity: 0.75;
            filter: alpha(opacity='75');
        }

        .mask .h3 {
            transform: translateY(0px);
            -webkit-transform: translateY(0px);
        }

        .mask p {
            transform: translateY(0px);
            -webkit-transform: translateY(0px);
        }
    }
</style>
